<template>
  <MaterialAlert :color="theme" fontWeight="bold">{{ text }}</MaterialAlert>
</template>

<script>
import MaterialAlert from "./MaterialAlert.vue";
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      default: "success",
    },
  },
  name: "Alert",
  components: {
    MaterialAlert,
  },
};
</script>
